<section style="padding:20px 5em 0 2em;" class="dashboard-bg">
    <!-- <p>Complete your profile to full access</p> -->
    <div *ngIf="status" class="dashboard">
        <div>
            <div *ngIf="openCoverExpiry" class="openCover">
                ! Your open cover window has expired or disabled, kindly do a reconciliation or contact admin to enable it. 
            </div>
            <div class="flex overview" style="justify-content: space-between;">
                <div class="overview-text">
                    <h2 style="font-size: medium;">Account Overview</h2>
                </div>
                <div *ngIf="policyButton" class="policy-btn">
                    <a routerLink="../create-policy" mat-raised-button color="accent">
                        <mat-icon style="color:white;">shopping_cart</mat-icon> Buy Policy
                    </a>
                </div>

            </div>
            <br>
            <br>
            <div id="cardCar" class="flex">
                <div style="flex:1;" class="flex">
                    <div class="boxy sMbdrRad contShadow">
                        <div class="flex">

                            <div class="flex" style="flex:2;align-items: start;">
                                <img src="../../assets/cert-icon.svg" alt="">
                                <!-- <mat-icon class="mat-18">star</mat-icon> -->
                            </div>
                            <div style="flex:6">
                                <header>
                                    <p>Total Certificates Generated</p>
                                </header>

                            </div>
                        </div>
                        <div style="height:60%;" class="flex">

                            <h3>{{user['certificate_count']}}</h3>
                        </div>
                    </div>
                </div>
                <div style="flex:1;animation-delay: .5s;" class="flex">
                    <div class="boxy sMbdrRad contShadow">
                        <div class="flex">

                            <div class="flex" style="flex:2;align-items: start;">
                                <img src="../../assets/gross-icon.svg" alt="">
                                <!-- <mat-icon class="mat-18">check_circle</mat-icon> -->
                            </div>
                            <div style="flex:6">
                                <header>
                                    <p>Gross Total</p>
                                </header>

                            </div>
                        </div>
                        <div style="height:60%;" class="flex">

                            <h3>{{gross | currency:"₦ "}}</h3>
                        </div>
                    </div>
                </div>
                <div style="flex:1 ;animation-delay: .85s;" class="flex">
                    <div class="boxy sMbdrRad contShadow">
                        <div class="flex">
                            <div class="flex" style="flex:2;align-items: start;">
                                <img src="../../assets/commission-icon.svg" alt="">
                                <!-- <mat-icon class="mat-18">refresh</mat-icon> -->
                            </div>
                            <div style="flex:6">
                                <header>
                                    <p>Total Commission Earned</p>
                                </header>
                            </div>
                        </div>
                        <div style="height:60%;" class="flex">
                            <h3>{{commission | currency:"₦ "}}</h3>
                        </div>
                    </div>
                </div>

                <div *ngIf="(user['role'] === 'staff' || user['role'] === 'broker')" style="flex:1 ;animation-delay: .100s;" class="flex">
                    <div class="boxy sMbdrRad contShadow">
                        <div class="flex">
                            <div class="flex" style="flex:2;align-items: start;">
                                <img src="../../assets/unit-icon.svg" alt="">
                                <!-- <mat-icon class="mat-18">refresh</mat-icon> -->
                            </div>
                            <div style="flex:6">
                                <header>
                                    <p>Unit Balance</p>
                                </header>
                            </div>
                        </div>
                        <div style="height:60%;" class="flex">
                            <h3>{{units | currency:"₦ "}}</h3>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <br>

        <div>
            <div class="sMbdrRad mat-elevation-z8 transactions">
                <h3 style="padding-left: 10px;">Recent Transactions</h3>
                <table mat-table [dataSource]="dataSource">

                    <!--- Note that these columns can be defined in any order.
                          The actual rendered columns are set as a property on the row definition" -->

                    <!-- Position Column -->
                    <ng-container matColumnDef="email">
                        <th mat-header-cell *matHeaderCellDef class="initiator">Initiator</th>
                        <td mat-cell *matCellDef="let element" class="initiator"> {{element.email}} </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="commission">
                        <th mat-header-cell *matHeaderCellDef> </th>
                        <td mat-cell *matCellDef="let element"> {{element.commission | currency:"NGN "}} </td>
                    </ng-container>
                    <ng-container matColumnDef="netPrice">
                        <th mat-header-cell *matHeaderCellDef class="net-price"> Net Price </th>
                        <td mat-cell *matCellDef="let element" class="net-price"> {{element.netPrice | currency:"NGN "}}
                        </td>
                    </ng-container>

                    <!-- Weight Column -->
                    <ng-container matColumnDef="grossPrice">
                        <th mat-header-cell *matHeaderCellDef class="gross"> Gross </th>
                        <td mat-cell *matCellDef="let element" class="gross"> {{element.grossPrice | currency:"NGN "}}
                        </td>
                    </ng-container>

                    <!-- commission Column -->

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="status"> Status </th>
                        <td mat-cell *matCellDef="let element" class="status"> {{element.status | titlecase}} </td>
                    </ng-container>
                    <ng-container matColumnDef="updated_at">
                        <th mat-header-cell *matHeaderCellDef class="date"> Date </th>
                        <td mat-cell *matCellDef="let element" class="date"> {{element.updated_at | date:'medium'}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="policy_detail_id">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let element">
                            <a routerLink="../policy-details/{{element.policy_detail_id}}" mat-button>View Details</a>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>
                <div class="flex" style="justify-content: end;"><a color="accent" routerLink="../completed-transactions"
                        mat-button>View All</a>
                </div>
            </div>
        </div>

        <div id="cardCar" class="charts">

            <div class="column mat-elevation-z8">
                <app-charts></app-charts>
            </div>

            <div class="side-chart">
                <div style="flex:1;" class="flex">
                    <div class="boxy sMbdrRad contShadow">
                        <div class="flex">
    
                            <div class="flex" style="flex:2;align-items: start;">
                                <img src="../../assets/cert-icon.svg" alt="">
                            </div>
                            <div style="flex:6">
                                <header>
                                    <p>Policy Count Issued</p>
                                </header>
    
                            </div>
                        </div>
                        <div style="height:60%;" class="flex">
    
                            <h3>{{policyCount}}</h3>
                        </div>
                    </div>
                </div>

                <div style="flex:1;animation-delay: .5s;" class="flex">
                    <div class="boxy sMbdrRad contShadow">
                        <div class="flex">
    
                            <div class="flex" style="flex:2;align-items: start;">
                                <img src="../../assets/gross-icon.svg" alt="">
                            </div>
                            <div style="flex:6">
                                <header>
                                    <p>Total Claims Amount</p>
                                </header>
    
                            </div>
                        </div>
                        <div style="height:60%;" class="flex">
    
                            <h3>{{claimAmount | currency:"₦ "}}</h3>
                        </div>
                    </div>
                </div>

                <div style="flex:1;animation-delay: .5s;" class="flex">
                    <div class="boxy sMbdrRad contShadow">
                        <div class="flex">
    
                            <div class="flex" style="flex:2;align-items: start;">
                                <img src="../../assets/gross-icon.svg" alt="">
                            </div>
                            <div style="flex:6">
                                <header>
                                    <p>Total Claims Count</p>
                                </header>
    
                            </div>
                        </div>
                        <div style="height:60%;" class="flex">
    
                            <h3>{{claimCount}}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="column mat-elevation-z8">
            <!-- <app-charts></app-charts> -->
            <app-charts-two></app-charts-two>
        </div>
    </div>

    <div *ngIf="!status" class="sMbdrRad mat-elevation-z8 pad">
        <h1>Hey 🖐 {{user['name']}}</h1>
        <br>
        <hr>
        <br>
        <p *ngIf="!user['cac_number']">
            Kindly submit your travel agency details so your account can be activated.
        </p>
        <p  *ngIf="user['cac_number']">
            Your account is currently under review. For further enquiries or complants, reach out to us using any of the
            below channels</p>
        <br>
        <br>

        <div class="flex">
            <div style="flex: 1;">
                <div>
                    <h3>Email</h3>
                    <a href="mailto:wecare@heirsgeneralinsurance.com">
                        <p>wecare"&#64;"heirsgeneralinsurance.com</p>
                    </a>
                </div>

            </div>
            <div style="flex: 1;">
                <div>
                    <h3>Tel</h3>
                    <a href="tel:+2348038721305">

                        <p>+234 (0) 803 872 1305</p>
                    </a>
                </div>

            </div>
            <div style="flex: 1;">
                <div>
                    <h3>Address</h3>
                    <address>plot 9, Ajose Adeogun, Victoria Island.</address>
                </div>

            </div>
        </div>
    </div>
    <div style="margin-top: 6em;"></div>

    
</section>